export const config = {
    backendUrl: 'https://cworkflow.com/api',
    appUrl: 'https://cworkflow.com/',
    appVersion: "3.0.0",
    // Mapa base (Leaflet). Proveedor de tiles configurable: cambia la URL/atribución
    // para usar MapTiler, Geoapify, Thunderforest, Stadia, etc. sin tocar código.
    // Default: MapTiler (raster). Reemplaza REEMPLAZA_TU_API_KEY por tu API key.
    mapTiles: {
        url: 'https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=EeDWAk6goDwAMvKIhH1w',
        attribution: '© <a href="https://www.maptiler.com/copyright/">MapTiler</a> © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
    },
    // Modo manos libres (llenado por voz).
    // `cadena` es el orden de preferencia cuando `proveedor` es 'auto': se toma
    // el primero que corra en el dispositivo. Cambiar de motor en toda la
    // instalación es editar este arreglo — nada más se toca.
    voz: {
        // Deepgram para TODO el reconocimiento, sin respaldo.
        //
        // El del navegador se probó en campo y transcribe demasiado mal para
        // este uso. Dejarlo como respaldo era peor que no tenerlo: llenaba los
        // campos con texto equivocado y daba la impresión de estar funcionando.
        // Si Deepgram no está disponible, el modo avisa y no se abre.
        //
        // Ojo: esto es sólo el RECONOCIMIENTO. Para hablar se siguen usando los
        // audios pregrabados y, para las frases sin grabar, la voz del
        // navegador — que sí sirve.
        proveedor: 'deepgram',              // 'auto' | 'webspeech' | 'deepgram'
        cadena: ['deepgram'],
        idioma: 'es-MX',
        // Quién interpreta lo que se dictó y lo convierte en el valor del campo:
        //   'local'  sólo el navegador (rápido y gratis, pero literal)
        //   'ia'     siempre Claude (entiende respuestas naturales; cuesta y tarda)
        //   'auto'   local primero, IA sólo cuando el local no resuelve
        // La IA es la única que puede sacar "31" de "24 de abril del 94" en un
        // campo de edad, porque hay que entender la pregunta, no sólo el texto.
        interpretacion: 'ia',
        // Segundos (en ms) para desdecirse de un valor recién registrado: se
        // muestra lo interpretado con un contador y se puede decir "repetir" o
        // tocar el botón. En 0 se pasa directo al campo siguiente.
        //
        // Cada ventana suma su duración al recorrido y una escucha más, así que
        // subirlo se paga cuarenta veces en un formulario de cuarenta campos.
        msCorreccion: 2000,
        // Audios pregrabados con `php artisan voz:generar`. Suenan mejor que la
        // voz del sistema y funcionan en cualquier navegador, porque son un
        // <audio> común y no la Web Speech API.
        audios: {
            // Relativo a appUrl. El manifiesto se carga al abrir el modo, así
            // que regenerar audios no obliga a recompilar el frontend.
            base: '',
            habilitado: true,
        },
    },
    turnstileSiteKey: '0x4AAAAAADUHIv7qbpYBo21h',
};
